import React, { useState, useEffect, useMemo } from 'react';

import { type Menu } from 'generated/graphql';
import { type MenuTile } from 'types';
import defaultMenuItem from 'icons/NoImage.svg';
import { Tile } from './Tile';
import { defaultMenuSection, groupByBrand, TileSection } from './tileUtils';

import styles from './Tiles.module.scss';

interface Props {
  menus?: Menu[] | undefined | null;
  isLoading?: boolean;
  venueName?: string;
  timezone?: string | null;
}

export const Tiles: React.FC<Props> = ({ menus, isLoading, venueName, timezone }) => {
  const [hasMounted, setHasMounted] = useState(false);

  const sections: TileSection[] = useMemo(
    () => (isLoading || !menus ? [defaultMenuSection] : groupByBrand(menus, venueName ?? 'Your Menus')),
    [menus, isLoading, venueName]
  );

  useEffect(() => {
    setTimeout(() => {
      setHasMounted(true);
    }, 10);
  }, []);
  return (
    <section
      className={`${styles.Outer} ${hasMounted ? styles.Mounted : defaultMenuItem} container`}
      data-testid="tiles-container"
      aria-labelledby="your-menus-heading"
    >
      {sections.map((section) => (
        <section key={section.name}>
          <div className={styles.SectionHeader}>
            <h2 id="your-menus-heading">{section.name}</h2>
          </div>
          <ul className={styles.List}>
            {section.menus.map((menu: MenuTile, index: number) => (
              <Tile
                key={menu.mmId}
                isLoading={isLoading}
                menu={menu}
                index={index}
                styles={styles}
                timezone={timezone}
              />
            ))}
          </ul>
        </section>
      ))}
    </section>
  );
};
